import React, { Component } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import Dropdownarrow from "../../../assets/new-grey-drop-down-arrow.svg";
export class CustomDropDown extends Component {
  onSelect = value => {
    const { onSelect } = this.props;
    typeof onSelect === "function" && onSelect(value);
  };

  render() {
    const {
      props: {
        id = "",
        selected = { key: "", title: "Select" },
        options = [],
        disabled = false,
        style,
        customStyle
      },
      onSelect
    } = this;

    return (
      <>
        <DropdownButton
          id={id || `dropdown-variants removeIcon`}
          title={
            <span
              // className={` ${style ? style : ""} ${
              //   selected.title !== "Select" && selected.title !== "Compose"
              //     ? "agenda-custom-color"
              //     : ""
              // } `}
              className="composetext"
            >
              {selected.title}
              <img src={Dropdownarrow} className="arrowbtn" />
            </span>
          }
          className="new-custom-dropdown"
          // className={`custom-drop-down ${
          //   customStyle ? "custom-style agenda-custom-dropdown" : ""
          // }`}
          disabled={disabled}
          focusFirstItemOnShow={false}
        >
          {options.map(value => {
            return (
              <Dropdown.Item
                className={`agenda-custom-color ${
                  customStyle ? "drop-down-item" : ""
                }`}
                onClick={() => onSelect(value)}
                eventKey={value.key}
              >
                {value.title}
              </Dropdown.Item>
            );
          })}
        </DropdownButton>
      </>
    );
  }
}
